import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import StarField from "@/components/StarField";
import TopBar from "@/components/TopBar";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function InfluencerLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "influencer" && u.role !== "admin") {
        toast.error("This portal is for approved influencers only");
        return;
      }
      toast.success("VIP access granted");
      navigate(u.role === "admin" ? "/admin" : "/influencer/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="relative min-h-screen">
      <StarField count={140} />
      <TopBar />
      <main className="relative z-20 flex items-center justify-center px-6 py-16">
        <div className="glass-strong rounded-sm p-10 w-full max-w-md">
          <div className="text-center">
            <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-fuchsia-400 mb-2">— restricted —</div>
            <h1 className="font-display text-3xl font-black uppercase neon-magenta">VIP Portal</h1>
            <p className="font-mono text-xs uppercase tracking-widest text-white/60 mt-4">Manually approved access only</p>
          </div>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="influencer-login-email" className="w-full px-4 py-3 bg-black/60 border border-white/15 rounded-sm font-mono text-sm focus:outline-none focus:border-fuchsia-400/80" />
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="influencer-login-password" className="w-full px-4 py-3 bg-black/60 border border-white/15 rounded-sm font-mono text-sm focus:outline-none focus:border-fuchsia-400/80" />
            <button type="submit" disabled={loading} data-testid="influencer-login-submit" className="gate w-full py-3 bg-fuchsia-500 text-black font-display font-bold uppercase tracking-[0.3em] text-xs rounded-sm hover:scale-[1.02] transition">
              {loading ? "..." : "Enter VIP"}
            </button>
          </form>
          <div className="text-center font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mt-6">
            <Link
              to="/forgot-password"
              className="text-fuchsia-400 hover:underline"
              data-testid="influencer-forgot-password-link"
            >
              Forgot password?
            </Link>
            <span className="mx-3 text-white/20">·</span>
            Not approved yet? <Link to="/influencer/apply" className="text-fuchsia-400 hover:underline" data-testid="influencer-apply-link">Apply</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
